/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_PreviewsInputs */

const en_svchip_previews = /** @type {(inputs: Svchip_PreviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previews`)
};

const ar_svchip_previews = /** @type {(inputs: Svchip_PreviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المعاينات`)
};

const bn_svchip_previews = /** @type {(inputs: Svchip_PreviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রিভিউ`)
};

const de_svchip_previews = /** @type {(inputs: Svchip_PreviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorschauen`)
};

const es_svchip_previews = /** @type {(inputs: Svchip_PreviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vistas previas`)
};

const fr_svchip_previews = /** @type {(inputs: Svchip_PreviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aperçus`)
};

const pt_svchip_previews = /** @type {(inputs: Svchip_PreviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prévias`)
};

const zh_svchip_previews = /** @type {(inputs: Svchip_PreviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预览`)
};

const tr_svchip_previews = /** @type {(inputs: Svchip_PreviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Önizlemeler`)
};

const ru_svchip_previews = /** @type {(inputs: Svchip_PreviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предварительный просмотр`)
};

const pl_svchip_previews = /** @type {(inputs: Svchip_PreviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podglądy`)
};

/**
* | output |
* | --- |
* | "Previews" |
*
* @param {Svchip_PreviewsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_previews = /** @type {((inputs?: Svchip_PreviewsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_PreviewsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_previews(inputs)
	if (locale === "bn") return bn_svchip_previews(inputs)
	if (locale === "de") return de_svchip_previews(inputs)
	if (locale === "es") return es_svchip_previews(inputs)
	if (locale === "fr") return fr_svchip_previews(inputs)
	if (locale === "pt") return pt_svchip_previews(inputs)
	if (locale === "zh") return zh_svchip_previews(inputs)
	if (locale === "tr") return tr_svchip_previews(inputs)
	if (locale === "ru") return ru_svchip_previews(inputs)
	if (locale === "pl") return pl_svchip_previews(inputs)
	return en_svchip_previews(inputs)
});